/* ============================================================
   INCIPIT · TIMELINE — Behaviors
   Path: assets/incipit-timeline.js
   Convention Incipit Studio.

   Dépendances : GSAP + ScrollTrigger
   ============================================================ */

(function() {
  'use strict';

  var INCIPIT_TIMELINE_DEBUG = false; // passe à true pour voir les logs

  function log() {
    if (INCIPIT_TIMELINE_DEBUG && window.console) {
      console.log.apply(console, ['[incipit-timeline]'].concat([].slice.call(arguments)));
    }
  }

  function initIncipitTimeline() {
    // Attente de GSAP (scripts deferred peuvent arriver après le DOMContentLoaded)
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      log('GSAP pas encore chargé, retry dans 60ms');
      return setTimeout(initIncipitTimeline, 60);
    }

    gsap.registerPlugin(ScrollTrigger);

    var sections = document.querySelectorAll('.incipit-timeline');
    if (!sections.length) {
      log('Aucune section trouvée');
      return;
    }

    log('Init ' + sections.length + ' section(s)');

    sections.forEach(function(section) {
      // Évite la double-init
      if (section.dataset.incipitInit === '1') return;
      section.dataset.incipitInit = '1';

      var track = section.querySelector('.incipit-timeline__track');
      var lineProgress = section.querySelector('.incipit-timeline__line-progress');
      var blocks = section.querySelectorAll('.incipit-timeline__block');

      if (!track || !lineProgress) {
        log('Track ou ligne introuvable, skip');
        return;
      }

      log('Track + ligne OK, ' + blocks.length + ' blocks');

      // ============================================================
      // 1. LIGNE CENTRALE — descend au scroll, scrub légèrement amorti
      // ============================================================
      gsap.to(lineProgress, {
        scaleY: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: track,
          start: 'top 50%',   // démarre quand le haut du track atteint 50% du viewport
          end: 'bottom 50%',  // finit quand le bas du track atteint 50% du viewport
          scrub: 0.4,
          // markers: true,   // décommente pour voir les triggers visuellement
          onUpdate: function(self) {
            log('ligne progress:', self.progress.toFixed(2));
          }
        }
      });

      // ============================================================
      // 2. APPARITION SÉQUENTIELLE des blocks
      // Chaque block reçoit .is-visible à top 65% — soit ≈ pile
      // quand la ligne arrive sur le year-marker.
      // ============================================================
      blocks.forEach(function(block, i) {
        ScrollTrigger.create({
          trigger: block,
          start: 'top 65%',
          end: 'bottom 35%',
          // markers: true,   // décommente pour debug
          onEnter: function() {
            block.classList.add('is-visible');
            log('block ' + i + ' visible');
          },
          onEnterBack: function() {
            block.classList.add('is-visible');
          },
          onLeaveBack: function() {
            block.classList.remove('is-visible');
          }
        });
      });

      // ============================================================
      // 3. PARALLAXE des images (desktop uniquement)
      // L'image (height: 140% en CSS) est centrée verticalement.
      // On la translate de +amplitude% à -amplitude% au scroll.
      // → effet "elles montent" pendant qu'on descend.
      //
      // Marge dispo : 20% en haut + 20% en bas (image à 140%).
      // Amplitude max safe : 8 × 1.5 (speed max) = 12% → reste dans la marge.
      // ============================================================
      var mm = gsap.matchMedia();
      mm.add('(min-width: 750px)', function() {
        section.querySelectorAll('.incipit-timeline__image').forEach(function(imgWrap) {
          var img = imgWrap.querySelector('img');
          if (!img) return;

          var speed = parseFloat(imgWrap.dataset.speed) || 1;
          var amplitude = 8 * speed; // base 8 (au lieu de 12)

          gsap.fromTo(
            img,
            { yPercent: amplitude },
            {
              yPercent: -amplitude,
              ease: 'none',
              scrollTrigger: {
                trigger: imgWrap,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true
              }
            }
          );
        });
      });
    });

    // Refresh ScrollTrigger après init complète (au cas où des images se chargent)
    ScrollTrigger.refresh();
    log('Init terminée, ScrollTrigger refreshed');
  }

  // ============================================================
  // BOOT
  // ============================================================
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initIncipitTimeline();
  } else {
    document.addEventListener('DOMContentLoaded', initIncipitTimeline);
  }

  // Refresh aussi après load complet (images, fonts, etc.)
  window.addEventListener('load', function() {
    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.refresh();
    }
  });

  // ============================================================
  // SHOPIFY THEME EDITOR — re-init lors des modifications live
  // ============================================================
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      var sec = e.target.querySelector('.incipit-timeline');
      if (sec) {
        sec.dataset.incipitInit = '';
        initIncipitTimeline();
      }
    });

    document.addEventListener('shopify:section:unload', function(e) {
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.getAll().forEach(function(t) {
          if (e.target.contains(t.trigger)) t.kill();
        });
      }
    });
  }
})();